import { configure } from "mobx";

// MobX 6 defaults to only allowing observed state to change inside actions.
// The stores were written for MobX 5, which allowed changes anywhere, so keep
// that behaviour. Imported first by each pack so it runs before any store.
configure({ enforceActions: "never" });
